export default __webpack_public_path__ + "static/media/vip-banner-id.6f95ccde.webp";